import About from "@/components/About";

export default function AboutPage() {
  return <About />;
}
